<template>
  <div>
    <div class="mdl-typography--caption typography--color-secondary number-line-legend-container text-left"
         v-if="showPositionLegend">
      <span class="position-label"></span>
      평균 점수
      <span class="typography--font-weight-500 position-score">{{ avgScore }}점</span>
    </div>

    <div class="number-line-container">
      <div class="nl-baseline">
        <div class="nl-tick" v-for="(_, index) in 11" v-bind:style="{ left: `${index * 10}%` }" v-bind:key="index"></div>
        <small class="nl-start-label typography--color-disabled">0점</small>
        <small class="nl-end-label typography--color-disabled">100점</small>

        <div class="nl-my-position" v-bind:style="{ left: `${myScore}%` }">
          <div class="position-icon"></div>
          <small class="nl-position-label" v-if="showPositionLabel">나</small>
        </div>

        <div class="nl-avg-position" v-bind:style="{ left: `${avgScore}%` }">
          <div class="position-icon"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'basic-number-line',

    props: {
      myScore: {
        type: Number,
        default: 50,
      },
      avgScore: {
        type: Number,
        default: 50,
      },
      showPositionLabel: {
        type: Boolean,
        default: false,
      },
      showPositionLegend: {
        type: Boolean,
        default: false,
      },
    },
  };
</script>

<style lang="scss">
  .number-line-legend-container {
    line-height: 14px;

    .position-label {
      display: inline-block;
      margin-right: 4px;
      width: 10px;
      height: 10px;
      border-radius: 100px;
      background-color: #ffffff;
      border: solid 1px #bebebe;
    }

    .position-score {
      margin-left: 6px;
    }
  }

  .number-line-container {
    position: relative;
    height: 48px;
    padding: 22px 0 8px;

    .nl-baseline {
      position: relative;
      background-color: rgba(0, 0, 0, 0.1);
      height: 4px;
      z-index: 1;
    }

    .nl-tick {
      position: absolute;
      border-left: 1px solid #e8e8e8;
      height: 8px;
      top: 0px;
      z-index: 2;
    }

    .nl-start-label {
      position: absolute;
      font-size: 12px;
      letter-spacing: 0.4px;
      top: 9px;
      left: 0;
    }

    .nl-end-label {
      position: absolute;
      font-size: 12px;
      letter-spacing: 0.4px;
      top: 9px;
      right: 0;
    }

    .nl-my-position {
      position: absolute;
      top: -8px;
      margin-left: -5px;
      z-index: 6;

      .position-icon {
        display: inline-block;
        width: 10px;
        height: 10px;
        border-radius: 100px;
      	background-color: #00c896;
      }

      .nl-position-label {
        position: absolute;
        font-size: 12px;
        font-weight: 500;
        color: rgba(0, 0, 0, 0.87);
        top: -16px;
        left: -6px;
        width: 22px;
        text-align: center;
      }
    }

    .nl-avg-position {
      position: absolute;
      margin-left: -8px;
      top: -6px;
      z-index: 5;

      .position-icon {
        display: inline-block;
        width: 16px;
        height: 16px;
        border-radius: 100px;
        background-color: #ffffff;
        border: solid 1px #bebebe;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// BasicNumberLine.vue?7db29713